import { render, staticRenderFns } from "./CompanyMemberPickerField.vue?vue&type=template&id=3e834446&scoped=true"
import script from "./CompanyMemberPickerField.vue?vue&type=script&lang=ts"
export * from "./CompanyMemberPickerField.vue?vue&type=script&lang=ts"
import style0 from "./CompanyMemberPickerField.vue?vue&type=style&index=0&id=3e834446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e834446",
  null
  
)

export default component.exports